import {IController} from "angular";
import * as angular from "angular";

export class planningRouteSuggestionsTimelineItemCtrl implements IController {

  service: any;
  isSelected: any;
  onDragStart: Function;

  constructor(private $element) {
  }

  $onInit() {
  }

  $onChanges(changes) {

  };

  $postLink() {
    this.$element.on('dragstart', (event) => {
      this.onDragStart({service: this.service, event: event});
    });
  };
}


angular
  .module('bringoz.admin.lean-planning')
  .component('planningRouteSuggestionsTimelineItem', {
    bindings: {
      service: '<',
      isSelected: '<',
      onDragStart: '&'
    },
    template: require('./planning-route-suggestions-timeline-item.html').default,
    controller: planningRouteSuggestionsTimelineItemCtrl
  });
